
import { API } from 'aws-amplify/'
import { navigate } from 'gatsby'
import { cartEmpty, emptyCart } from './rootstate'

var cartState = {}
let cartStatePromise;

const post = (promise, store, path, body, options, updateAndSave) => {
    let newState = { ...store, ...{ calculating: true } }

    updateAndSave(newState)
    try {
        const postData = {
            headers: {
                "Content-Type": "application/json"
            },
            body: body
        }

        API.post('api', path, postData)
            .then((data) => {
                    if (data.ss) {
                        newState = {
                            ...newState,
                            ...{
                                cartInitialised: true,
                                emailAddress: data && data.ts && data.ts.email ? data.ts.email : "",
                                ss: data.ss,
                                ts: data.ts,
                                os: data.os,
                                pd: data.pd ? data.pd : {},
                                so: data.so ? data.so : [],
                                soe: data.soe ? data.soe : [],
                                // sr: data.sr ? data.sr : {},
                                // pr: data.pr ? data.pr : {}
                            }
                        }
                        console.log("NEW STATE", newState)
                        updateAndSave(newState)

                        if (!data.ss.oid || data.ss.oid == "") {
                            newState = emptyCart (newState)
                        }
                    }

                    if (data.pd && data.pd.pi) {

                        if (store.preparePayment == true || store.showPayment == true) {
                            newState = {
                                ...newState,
                                ...{
                                    preparePayment: false,
                                    showPayment: true,
                                    ...{ calculating: false },
                                    ...{ countryChange: false },
                                    accordianItem: 2
                                },
                                // Preserve cartOpen state to prevent unwanted closing
                                cartOpen: store.cartOpen
                            }
                            updateAndSave(newState)
                        }

                    } else {
                        newState = {
                            ...newState,
                            ...{ calculating: false },
                            ...{ countryChange: false },
                            ...{
                                paymentRequest: null
                            }
                        }
                        updateAndSave(newState)
                    }
            })
            .finally(() => {
                newState = {
                    ...newState,
                    ...{ calculating: false },
                    ...{ countryChange: false },
                    // Preserve cartOpen state to prevent unwanted closing
                    cartOpen: store.cartOpen
                }
                updateAndSave(newState)
            }).catch((err) => {
                newState = {
                    ...newState,
                    ...{ calculating: false },
                    ...{ countryChange: false },
                    ...{ error: err },
                    // Preserve cartOpen state to prevent unwanted closing
                    cartOpen: store.cartOpen
                }
                updateAndSave(newState)
            })
    } catch (e) {
        newState = {
            ...newState,
            ...{ calculating: false },
            // ...{ countryChange: false },
            ...{ error: e },
            // Preserve cartOpen state to prevent unwanted closing
            cartOpen: store.cartOpen
        }
        updateAndSave(newState)
    }
}

export function clearShipping() {
    updateAndSave({
        showPayment: false,
        packagingID: "",
        shippingID: "",
        so: [],
        soe: [],
        sr: {},
    })
}

export function fetchCartState(store, updateAndSave, force) {
    // Don't fetch cart on payment page - it's a standalone page
    if (typeof window !== 'undefined' && window.location.pathname.includes('/payment')) {
        return
    }

    const items = store.cartProducts ? store.cartProducts.map(item => (
        {
            ownGarment: item.own_garment,
            kvatt: item.kvatt,
            sku: item.sku,
            quantity: item.quantity,
        }
    )) : []
    post(cartStatePromise, store, "/checkout/cart", {
        ss: store.ss,
        ca: {
            items: items,
            promo: store.promoCode && store.promoCode.promo_code ? store.promoCode.promo_code : "",
            // Shipping Address
            sa: {
                ...store.shipping_address,
                phone: store.contactNumber,
                name: store.fullName
            },
            // Shipping & Packaging
            sp: {
                shippingID: store.shippingID,
                packagingID: store.packagingID
            },
            cd: {
                email: store.emailAddress,
                marketing: store.marketing
            }
        },
    }, null, updateAndSave)
}

/**
 * Warm up the cart lambda without affecting user state
 * This function sends a warmup ping to the same cart endpoint with a warmup flag
 */
export function warmUpCartLambda() {
    if (typeof window === 'undefined') return

    try {
        const postData = {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                warmup: true,
                timestamp: Date.now()
            })
        }

        API.post('api', '/checkout/cart', postData)
            .then(() => {
            })
            .catch((error) => {
            })
    } catch (error) {
    }
}


/**
 * Fetch payment receipt data
 * @param {string} paymentIntent - Payment intent ID
 * @param {string} orderId - Order ID
 * @returns {Promise<Object>} Payment receipt data
 */
export const fetchReceipt = async (paymentIntent, orderId) => {
  const data = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      "payment_intent": paymentIntent,
      "order_id": orderId
    })
  }

  return API.post('api', '/checkout/receipt', data)
}

/**
 * Fetch payment intent data
 * @param {string} paymentIntent - Payment intent ID
 * @param {string} orderId - Order ID
 * @returns {Promise<Object>} Payment intent data
 */
export const fetchPaymentIntent = async (paymentIntent, orderId) => {
  const data = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: {
      "payment_intent": paymentIntent,
      "order_id": orderId
    }
  }

  return API.post('api', '/intent/retrieve', data)
}

/**
 * Fetch express checkout shipping options
 * @param {Object} store - Current store state
 * @returns {Promise<Object>} Express checkout shipping options
 */
export const fetchExpressShippingOptions = async (store) => {
  try {

    const items = store.cartProducts ? store.cartProducts.map(item => ({
      ownGarment: item.own_garment,
      kvatt: item.kvatt,
      sku: item.sku,
      quantity: item.quantity,
    })) : [];

    const cartData = {
      ss: store.ss,
      ca: {
        items: items,
        promo: store.promoCode && store.promoCode.promo_code ? store.promoCode.promo_code : "",
        // Use current shipping address from global state
        sa: store.shipping_address || {
          country_code: 'GB',
          zip: 'EC2Y 5HN',
          address1: '',
          address2: '',
          city: 'London',
          locality: '',
          name: '',
          phone: '',
          complete: true
        },
        // Use current shipping & packaging
        sp: {
          shippingID: store.shippingID,
          packagingID: store.packagingID
        },
        cd: {
          email: store.emailAddress
        }
      },
    };

    const postData = {
      headers: {
        "Content-Type": "application/json"
      },
      body: cartData
    };

    const result = await API.post('api', '/checkout/cart', postData);
    return result;
  } catch (error) {
    throw error;
  }
}